'use strict';

var tslib_es6 = require('./tslib.es6-13d783d6.js');
var React = require('react');
var styled = require('styled-components');
var CloseIcon = require('./CloseIcon-978b729e.js');
var typography_index = require('./typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _a;
(function (BubbleType) {
    BubbleType[BubbleType["DEFAULT"] = 0] = "DEFAULT";
    BubbleType[BubbleType["GREY"] = 1] = "GREY";
})(exports.BubbleType || (exports.BubbleType = {}));
var bubbleHeightDefault = '35px';
var bubbleGreyModifier = styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    ", "\n    background-color: ", ";\n    border: none;\n\n    &[aria-current='true'] {\n        background-color: ", ";\n    }\n"], ["\n    ", "\n    background-color: ", ";\n    border: none;\n\n    &[aria-current='true'] {\n        background-color: ", ";\n    }\n"])), typography_index.plainTextStyle, function (_a) {
    var colors = _a.theme.colors;
    return colors.charcoal3;
}, function (_a) {
    var colors = _a.theme.colors;
    return colors.charcoal20New;
});
var bubbleDefaultModifier = styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    &[aria-current='true'] {\n        border: ", ";\n    }\n"], ["\n    &[aria-current='true'] {\n        border: ", ";\n    }\n"])), function (_a) {
    var colors = _a.theme.colors;
    return "2px solid " + colors.charcoal100;
});
var bubbleModifier = (_a = {},
    _a[exports.BubbleType.GREY] = bubbleGreyModifier,
    _a[exports.BubbleType.DEFAULT] = bubbleDefaultModifier,
    _a);
var StyledBubble = styled__default['default'].a.withConfig({ displayName: "ww-uikit_StyledBubble_kzprkaem", componentId: "sc-zjbdpe" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    text-decoration: none;\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    border: ", ";\n    border-radius: 20px;\n    padding: 0 15px;\n    margin: 0 7px 7px;\n    color: inherit;\n    cursor: pointer;\n\n    ", "\n"], ["\n    text-decoration: none;\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    border: ", ";\n    border-radius: 20px;\n    padding: 0 15px;\n    margin: 0 7px 7px;\n    color: inherit;\n    cursor: pointer;\n\n    ", "\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var colors = _a.theme.colors;
    return "1px solid " + colors.charcoal20;
}, function (_a) {
    var bubbleType = _a.bubbleType;
    return bubbleModifier[bubbleType || exports.BubbleType.DEFAULT];
});
var StyledCloseButton = styled__default['default'](CloseIcon.CloseIcon).withConfig({ displayName: "ww-uikit_StyledCloseButton_kzprkaen", componentId: "sc-1tqgdmt" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    margin-right: 7px;\n"], ["\n    margin-right: 7px;\n"])));
var Bubble = React.forwardRef(function (_a, ref) {
    var _b = _a.bubbleType, bubbleType = _b === void 0 ? exports.BubbleType.DEFAULT : _b, text = _a.text, href = _a.href, as = _a.as, selected = _a.selected, _c = _a.height, height = _c === void 0 ? bubbleHeightDefault : _c, callback = _a.callback, otherProps = tslib_es6.__rest(_a, ["bubbleType", "text", "href", "as", "selected", "height", "callback"]);
    var handleClick = function (event) {
        if (callback) {
            callback({ text: text, href: href, selected: selected }, event);
        }
    };
    return (React__default['default'].createElement(StyledBubble, tslib_es6.__assign({ bubbleType: bubbleType, ref: ref, href: href, as: as, "aria-current": selected, height: height, onClick: handleClick }, otherProps),
        selected && React__default['default'].createElement(StyledCloseButton, null),
        text));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.Bubble = Bubble;
exports.bubbleHeightDefault = bubbleHeightDefault;
//# sourceMappingURL=Bubble-0f737416.js.map
